<template>
    <div id="mobile-detail-acq-f-t-cta">
        <!--/* message d'alerte en cas d'absence de ctas */-->
        <div v-if="offersHref == null && onlineHref == null && eresaHref == null" class="row">
            <div class="col-12 pt-2">
                <ob1-message-alerte
                    :is-simple-alerte="false"
                    :title="alertStatusDto.title"
                    :text="alertStatusDto.message"
                    :type="'warning'"
                />
            </div>
        </div>

        <div v-else-if="offersHref">
            <mobileDetailsCtaAndAvailabilityMentions
                :available-online="availableOnline"
                :estimated-delivery-label="estimatedDeliveryLabel"
                :available-eresa="availableEresa"
                :preorder-mention="preorderMention"
                :label="buttonLabel"
                :href="authenticationPopinLabels ? null : offersHref"
                :data-target="authenticationPopinLabels ? '#authenticationPopIn' : null"
            />
            <authentication-popin
                v-if="authenticationPopinLabels"
                :id="'authenticationPopIn'"
                :title="authenticationPopinLabels.title"
                :subtitle="authenticationPopinLabels.subtitle"
                :new-client-title="authenticationPopinLabels.newClientTitle"
                :new-client-description="authenticationPopinLabels.newClientDescription"
                :new-client-href="offersHref"
                :client-title="authenticationPopinLabels.alreadyClientTitle"
                :client-description="authenticationPopinLabels.alreadyClientDescription"
                :client-href="offersClientHref"
            />
        </div>

        <!--/* Les ctas TDC et C&C sont à afficher : on les affiche dans une popin */-->
        <div v-else-if="onlineHref && eresaHref">
            <mobileDetailsCtaAndAvailabilityMentions
                :available-online="availableOnline"
                :estimated-delivery-label="estimatedDeliveryLabel"
                :available-eresa="availableEresa"
                :label="buttonLabel"
                :preorder-mention="preorderMention"
                :data-target="'#allDisponibilitiesPopIn'"
            />
            <all-disponibilities-popin
                :title="allDisponibilitiesPopin.title"
                :tdc-section="allDisponibilitiesPopin.tdcSection"
                :eresa-section="allDisponibilitiesPopin.eresaSection"
                :eco-foot-note="allDisponibilitiesPopin.ecoFootNote"
                :tdc-href="onlineHref"
                :eresa-href="eresaHref"
            />
        </div>

        <!--/* Seul le cta TDC ou celui du C&C est actif : on l'affiche dans le coeur de page */-->
        <div v-else>
            <!--/* cta TDC */-->
            <mobileDetailsCtaAndAvailabilityMentions
                :available-online="availableOnline"
                :estimated-delivery-label="estimatedDeliveryLabel"
                :available-eresa="availableEresa"
                :preorder-mention="preorderMention"
                :label="buttonLabel"
                :href="onlineHref ? onlineHref : eresaHref"
            />
        </div>
    </div>
</template>

<script>

import AllDisponibilitiesPopin from "../../common/components/AllDisponibilitiesPopin.vue";
import MobileDetailsCtaAndAvailabilityMentions
    from "../../common/mobiledetails/MobileDetailsCtaAndAvailabilityMentions.vue";
import AuthenticationPopin from "./AuthenticationPopin.vue";

export default {
    name: "MobileDetailsCtaAcquisition",
    components: {
        AuthenticationPopin,
        MobileDetailsCtaAndAvailabilityMentions,
        AllDisponibilitiesPopin,
    },
    props: {
        offersHref: {
            type: String,
            required: false,
            default: null
        },
        offersClientHref: {
            type: String,
            required: false,
            default: null
        },
        onlineHref:{
            type: String,
            required: false,
            default: null
        },
        eresaHref:{
            type: String,
            required: false,
            default: null
        },
        alertStatusDto: {
            type: Object,
            required: true
        },
        allDisponibilitiesPopin: {
            type: Object,
            required: true
        },
        buttonLabel: {
            type: String,
            required: true
        },
        preorderMention: {
            type: String,
            required: false,
            default: null
        },
        availableOnline: {
            type: Boolean,
            required: true
        },
        estimatedDeliveryLabel: {
            type: String,
            default: null
        },
        availableEresa: {
            type: Boolean,
            required: true
        },
        authenticationPopinLabels: {
            type: Object,
            required: false,
            default: null
        }
    }
}
</script>
